class Utility {

  static truncate(string: string, max: number): string {
    if (max < string.length) {
      return string.substring(0, max) + "...";
    }

    return string;
  }

  static factorial = (x: number): number => {
    if (x === 0) {
      return 1;
    }
    return x * Utility.factorial(x-1);
  }

  static insertStr = (str: string, index: number, value: string): string => {
    return str.substr(0, index) + value + str.substr(index);
  }

}

export default Utility;
